<!-- 各类型农机检验数 (前十名) -->
<template>
  <div :id="id" :style="{ height: height, width: width }" />
</template>
<script>
import * as echarts from "echarts";
import resize from "@/components/chart/mixins/resize";
let chartVm = null;
function toThousandFilter(num) {
  return (+num || 0)
    .toString()
    .replace(/^-?\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ","));
}
export default {
  mixins: [resize],
  props: {
    id: {
      type: String,
      default: "rightThirdchart",
    },
    width: {
      type: String,
      default: "90%",
    },
    height: {
      type: String,
      default: "100%",
    },
    chartData: {
      type: Object,
      default: () => {
        return {
          names: [],
          nums: [],
        };
      },
    },
  },
  data() {
    return {
      chart: null,
      // 立体柱状图颜色
      colorArr: [
        ["rgba(7, 125, 68, ", "rgba(25, 218, 125, "],
        ["rgba(4, 93, 50, ", "rgba(3, 117, 62, "],
      ],
      options: {
        // tooltip: {
        //     trigger: 'axis',
        //     axisPointer: {
        //         type: 'shadow'
        //     }
        // },
        grid: [
          {
            top: "6%",
            bottom: "14%",
            right: "30%",
            left: "10%",
            width: "61%",
          },
          // {
          //   top: '6%',
          //   bottom: '10%',
          //   right: '2%',
          //   width: '0%'
          // }
        ],
        dataZoom: [
          {
            type: "slider",
            yAxisIndex: 0,
            startValue: 0,
            endValue: 4,
            zoomLock: true,
            show: false,
          },
        ],
        xAxis: {
          type: "value",
          inverse: true,
          axisTick: {
            show: false,
          },
          axisLabel: {
            formatter: (value, index) => (index % 2 === 0 ? value : ""), // 每隔一个显示
            color: "#BABBBD",
            fontSize: 12,
            margin: -1,
          },
          splitLine: false,
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          name: "(台)",
          position: "right",
          nameTextStyle: {
            color: "#BABBBD",
            fontSize: 12,
            align: "right",
            verticalAlign: "top", // 底部对齐
            padding: [0, -54, 0, 0],
          },
          nameLocation: "start",
          nameGap: -2, // 调整名称与轴的距离
          type: "category",
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            interval: 0,
            color: "#BABBBD",
            fontSize: 12,
            align: "left",
            margin: 8,
            formatter: function (params) {
              const maxChars = 5; // 每行字符数
              let result = "";
              for (let i = 0; i < params.length; i += maxChars) {
                result += params.substring(i, i + maxChars) + "\n";
              }
              return result.trim();
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(88, 252, 146, 0.17)",
              width: 2,
            },
          },
        },
      },
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.initChart();
      },
    },
  },
  mounted() {
    this.initChart();
    chartVm = this;
  },
  created() {},
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById(this.id));
      }
      this.setChartData();
    },
    setChartData() {
      this.options.yAxis.data = this.chartData.names;
      let series = [];
      let that = this;
      // 左侧立体柱状图上
      series.push({
        name: "使用比例",
        type: "bar",
        barGap: 0,
        barWidth: "3",
        data: that.chartData.nums,
        label: {
          show: true,
          padding: [12, 0, 0, 2],
          position: "left",
          color: "#FFFFFF",
          formatter: function (params) {
            if (params.value > 0) {
              return toThousandFilter(params.value);
            } else {
              return "";
            }
          },
        },
        itemStyle: {
          normal: {
            color: function (params) {
              return new echarts.graphic.LinearGradient(
                0,
                0,
                1,
                0,
                //渐变色在下面修改，这里是透明度
                [
                  {
                    offset: 0,
                    color: that.colorArr[1][1] + "0.9)",
                  },
                  {
                    offset: 1,
                    color: that.colorArr[1][0] + "0.9)",
                  },
                ]
              );
            },
          },
        },
      });
      // 左侧立体柱状图下
      series.push({
        type: "bar",
        barGap: 0,
        barWidth: "9",
        data: that.chartData.nums,
        itemStyle: {
          normal: {
            color: function (params) {
              return new echarts.graphic.LinearGradient(
                0,
                0,
                1,
                0,
                //渐变色在下面修改，这里是透明度
                [
                  {
                    offset: 0,
                    color: that.colorArr[0][1] + "1)",
                  },
                  {
                    offset: 1,
                    color: that.colorArr[0][0] + "1)",
                  },
                ]
              );
            },
          },
        },
      });
      this.options.series = series;
      this.chart.setOption(this.options);
    },
  },
};
</script>
